import React, { useEffect, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import VerifiedSignature from "../../../../img/documentsign.png";
import Swal from "sweetalert2";
import Moment from "react-moment";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { BiLockAlt } from "react-icons/bi";

const FormReview = ({
  formId,
  getStudyLevelFormFieldsByVersion,
  Show,
  Hide,
  Title,
  setDVQualityCheck,
  setDBPQualityCheck,
  getStudyLevelForm,
}) => {
  const [password, setPassword] = useState("");
  let { studyId } = useParams();
  const firstName = JSON.parse(localStorage.getItem("firstName"));
  const lastName = JSON.parse(localStorage.getItem("lastName"));
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const digitalSignatureStudyLevelForm = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Signature provied to the Form!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, sign it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.formId = formId;
        userData.studyId = studyId;
        userData.password = password;
        userData.mode = StudyMode;
        let data =
          await studyLevelFormManagementServices.digitalSignatureStudyLevelForm(
            userData
          );
        if (data?.statusCode === 200) {
          if (StudyMode === "DBP Mode") {
            setDBPQualityCheck("yes");
          }
          if (StudyMode === "DV Mode") {
            setDVQualityCheck("yes");
          }
          getStudyLevelForm();
          getStudyLevelFormFieldsByVersion();
          Hide();
          setPassword("");
        }
      }
    });
  };

  const [checkbox, setCheckbox] = useState(false);
  const [signatureHash, setSignatureHash] = useState("");

  function generateRandomCode(length = 9) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    if (!result || result.length <= 6) return result;
    const start = result.slice(0, 3);
    const end = result.slice(-3);
    const masked = "*".repeat(result.length - 6);
    return start + masked + end;
  }

  useEffect(() => {
    setSignatureHash(generateRandomCode(18))
  }, []);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group
            style={{ textAlign: "justify", fontSize: 13 }}
            className="mb-3"
          >
            <p className="m-0 bg-success-subtle p-2">
              You are required to provide a signature for this activity in order
              to fully complete it. This records that you are signing off theat
              you have taken, and completed this online review activity. This
              will resilt in the completion record being recorded in your review
              history.
            </p>
          </Form.Group>
          <div className="p-3 border rounded bg-light lh-1 mb-2">
            <small className="fw-bold"><BiLockAlt /> Electronic Signature</small>
            <Form.Label style={{ fontSize: 10 }}>
              Per 21 CFR Part 11, re-enter your password to authorise this
              action.
            </Form.Label>
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Username</Form.Label>
              <Form.Control disabled value={`${firstName || ""} ${lastName || ""}`} type="text" placeholder="Enter username" />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold mb-1">
                Password{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                className="br3"
                placeholder="Password"
                type="password"
              />
            </Form.Group>
          </div>
          <div className="p-2 border rounded mb-2">
            <div
              className="border border-2 rounded-start border-success border-end-0 position-relative"
              style={{ maxWidth: "fit-content" }}
            >
              <div className="p-3">
                <div className="hstack gap-2">
                  <h6 className="m-0 fw-bold">
                    {firstName}
                    <br />
                    {lastName}
                  </h6>

                  <div>
                    <p
                      className="m-0"
                      style={{ fontSize: 9 }}
                    >
                      Digitally signed by
                      <br />
                      {firstName} {lastName || ""}
                    </p>

                    <p
                      className="m-0"
                      style={{ fontSize: 9 }}
                    >
                      Date:
                      <Moment
                        format="DD/MM/YYYY"
                        withTitle
                      >
                        {new Date()}
                      </Moment>
                      |
                      <br />
                      <Moment
                        format="HH:mm:ss"
                        withTitle
                      >
                        {new Date()}
                      </Moment>
                      - GMT+06:30
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="position-absolute bg-white w-100"
                style={{
                  top: -10,
                  left: 30,
                }}
              >
                <p className="fw-bold m-0 ps-1">
                  eSigned By:
                </p>
              </div>

              <div
                className="position-absolute bg-white w-100"
                style={{
                  bottom: -10,
                  left: 30,
                }}
              >
                <p className="fw-bold m-0 ps-1">
                  {signatureHash}
                </p>
              </div>

              <img
                className="position-absolute"
                style={{
                  top: 8,
                  left: 47,
                  pointerEvents: "none",
                  filter: "opacity(0.2)",
                  width: 70,
                }}
                src={VerifiedSignature}
                alt="Signed"
              />
            </div>
          </div>
          <Form.Check onChange={(e) => setCheckbox(!checkbox)} checked={checkbox} label="I confirm the attestation above and understand this signature is permanent and cannot be removed." />
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            disabled={!checkbox || !password}
            className="updateProfile"
            onClick={(e) => digitalSignatureStudyLevelForm(e)}
          >
            Sign Now
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default FormReview;
